import { useState, type FormEvent } from "react";
import { Modal } from "./Modal";

/** Replaces window.confirm / window.prompt so destructive actions look like the
 *  rest of the app, can validate input, and cannot be suppressed by the browser. */
export function ConfirmDialog({ title, message, confirmLabel = "Confirm", danger, reasonLabel, reasonPlaceholder, onConfirm, onClose }: {
  title: string; message: string; confirmLabel?: string; danger?: boolean;
  reasonLabel?: string; reasonPlaceholder?: string;
  onConfirm: (reason: string) => void; onClose: () => void;
}) {
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = Boolean(reasonLabel) && !reason.trim();
  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setTouched(true);
    if (invalid) return;
    onConfirm(reason.trim());
  }
  return <Modal title={title} onClose={onClose}>
    <form className="product-form confirm-dialog" onSubmit={submit}>
      <p className="confirm-message">{message}</p>
      {reasonLabel && <div className="field-grid"><label className="field field-wide"><span>{reasonLabel}</span>
        <input autoFocus value={reason} onChange={(event) => setReason(event.target.value)} placeholder={reasonPlaceholder} maxLength={500}/>
        {touched && invalid && <small className="field-error">This is required.</small>}
      </label></div>}
      <div className="modal-actions">
        <button type="button" className="secondary-button" onClick={onClose}>Cancel</button>
        <button className={danger ? "save-button danger-action" : "save-button"} disabled={invalid && touched}>{confirmLabel}</button>
      </div>
    </form>
  </Modal>;
}
